import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
// import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";

import LandingPageHome from "./Views/LandingPage/Home";
import ContactUs from "./Views/LandingPage/ContactUs";
import ConsultationProgram from "./Views/ConsultationProgram";
import Careers from "./Views/Careers";
import PastProjects from "./Views/PastProjects";
import ProjectDetails from "./Views/PastProjects/ProjectDetails";
import About from "./Views/aboutUs/index";
import MedCoCaseStudy from "./Views/LandingPage/CaseStudies/MedCo";
import LightningCaseStudy from "./Views/LandingPage/CaseStudies/Lightning";
import PrivacyPolicy from "./Views/PrivacyPolicy";
import theme from "./assets/theme";
import WhatsAppButton from "components/WhatsAppButton";

export default function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WhatsAppButton />
      <Routes>
        {getRoutes(routes)}
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/" element={<LandingPageHome />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/ConsultationProgram" element={<ConsultationProgram />} />
        <Route path="/Careers" element={<Careers />} />
        <Route path="/PastProjects" element={<PastProjects />} />
        <Route path="/PastProjects/Details" element={<ProjectDetails />} />
        <Route path="/AboutUs" element={<About />} />
        <Route path="/case-studies/medco" element={<MedCoCaseStudy />} />
        <Route
          path="/case-studies/lightning"
          element={<LightningCaseStudy />}
        />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}
